module.exports = __webpack_public_path__ + "static/media/SX.5b0ff302.png";